<div class="main-div">
    <h2 class="signaturit_big_title">{{ 'title_registro' | translate:_transParam }}</h2>
    <mat-card-content>
        <div #com class="carpetero">
            <div #hea class="carpetero-head" *ngIf="!hasGuid && showRegisterQPers">
                <div class="p-2 cabecera mat-expansion-panel-header" (click)="ocultar_mostrar(1);">
                    <div class="mat-content">
                        <div class="cabecera-title">
                            {{ 'registro_tab_cert' | translate:_transParam }}
                        </div>
                        <span #indicatorQ class="cabecera-indicator mat-expansion-indicator text-center"></span>
                        <div class="cabecera-subtitle fs-13">
                            <p> {{ 'registro_tab_cert_subtitle' | translate:_transParam }}</p>
                        </div>
                    </div>
                </div>
                <div class="p-2 cabecera mat-expansion-panel-header" (click)="ocultar_mostrar(2);">
                    <div class="mat-content">
                        <div class="cabecera-title">
                            {{ 'registro_tab_user' | translate:_transParam }}
                        </div>
                        <span #indicatorU class="mat-expansion-indicator"></span>
                        <div class="cabecera-subtitle fs-13">
                            <p>{{ 'registro_tab_user_subtitle' | translate:_transParam }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div #bod class="w-100 carpetero-body">
                <div #contentQ class="carpetero-content" id="regCert">
                    <iv-form #formQ [errorsForm]="erroresForm" [columnsForm]="configFormQ" [labels]="labelsQ"
                        buttons="{save: false, clear: false}" (onSaveClick)="submitForm(1)">
                    </iv-form>
                    <div class="botonera full-width text-center">
                        <signaturit-button class="buttons" text="{{ 'btn_limpiar' | translate:_transParam }}"
                            type="tertiary" size="md" (click)="clear(formQ)"></signaturit-button>
                        <signaturit-button class="buttons" text="{{ 'btn_guardar' | translate:_transParam }}"
                            type="secondary" size="md" (click)="submitForm(1)"></signaturit-button>
                        <signaturit-button class="buttons"
                            text="{{ 'registro_btn_certificate' | translate:_transParam }}" type="secondary" size="md"
                            (click)="fillForm()"></signaturit-button>
                    </div>
                </div>
                <div #contentU class="registro-usuario carpetero-content" id="regUser">
                    <iv-form #formU [errorsForm]="erroresForm" [title]="" [columnsForm]="configFormU" [labels]="labels"
                        (onSaveClick)="submitForm(2)" [color]="'primary'|colors" [textColor]="'text'|colors">
                    </iv-form>
                </div>
            </div>
        </div>
        <div class="w-100 mt-3 text-center">
            <signaturit-button text="{{'registro_btn_return' | translate:_transParam }}" type="secondary" size="md"
                (click)="volver()" icon="arrow_back"></signaturit-button>
        </div>
    </mat-card-content>
</div>